import { Suspense, useState } from 'react';

import { Outlet } from 'react-router-dom';

import VaultDialog from '@/pages/vault/VaultDialog';
import { useUserStore } from '@/store';
import { Footer } from '../template/Footer';
import { Navbar } from '../template/navbar/Navbar';
import PageLoader from '../template/PageLoader';

// interface User {
//   vaultId?: string | null;
//   roleId?: number | null;
// }
const UserLayout = () => {
  const { user } = useUserStore();

  // const [isVaultIdAvailable, setIsVaultIdAvailable] = useState(
  //   !!(user?.user as User)?.vaultId
  // );
  const [isVaultIdAvailable, setIsVaultIdAvailable] = useState(
    !!(user?.vaultConnected)
  );
  return (
    <>
      <VaultDialog
        isOpen={!isVaultIdAvailable}
        onVaultConnected={() => setIsVaultIdAvailable(true)}
      />
      <div className="flex flex-col min-h-screen w-full relative ">
        <Navbar />
        <div className=" flex flex-auto flex-col justify-between mt-14 ">
          <Suspense fallback={<PageLoader />}>
            <main className="relative h-full flex flex-auto flex-col ">
              <Outlet />
            </main>
          </Suspense>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default UserLayout;
